export default __webpack_public_path__ + "static/logo-48d1afd70a56fbe8e60b2bcb17e40aba.png";